import './index.styl';
import { View } from 'backbone.marionette';
import template from './index.jst';
import Radio from 'backbone.radio';
import { Preloader, isMobileView } from '../../../../utils';

export class PlayerItem extends View {
	get template() {
		return template;
	}

	get className() {
		let model = this.model;

		if (model && model.get('is_locked')) {
			return 'player-pool-item is-locked';
		}

		return 'player-pool-item';
	}

	get tagName() {
		return 'li';
	}

	ui() {
		return {
			add: '.js-add',
			coach: '.js-coach-locked'
		}
	}

	events() {
		return {
			'click @ui.add': 'onPlayerAdd',
			'click': 'onPlayerShowPopup',
			'click @ui.coach': 'onClickCoach'
		}
	}

	onPlayerAdd(event) {
		event.stopPropagation();

		if (isMobileView()) {
			Preloader.showImmediately();
		}

		this.trigger('player:add', { model: this.model });
	}

	onPlayerShowPopup() {
		const
			id = parseInt(this.model.get('id'), 10),
			is_locked = this.model.get('is_locked');

		this.trigger('player:show:popup', { id, is_locked });
	}

	onClickCoach(event) {
		event.stopPropagation();

		Radio.channel('coach').trigger('show:popup');
	}
}

export default PlayerItem;